module.exports = {
  "id": "friction",
  "icon": "paperplane",
  "color": "green",
  "title": "glide",
  "category": "movement",
  "info": [
    {
      "text": "Make a piece glide when it moves",
      "image": "provision/glitches/friction/friction.gif"
    }
  ],
  "searchTags": [],

  "exposedVariables": [
    {
      "tooltip":"Set how strong friction is for this piece",
      "value": ".33",
      "variableName": "friction",
      "spriteName": "$glitch_target",
      "input": {
        "type": "slider",
        "min": "0",
        "max": "1",
        "options": [],
        "step": ".01"
      }
    }
  ],
  "codeImage": "provision/glitches/friction/friction.png",
  "code": null,
  "zip": null,
  "sb3": null,
  "isRemix": true,
  "image": "provision/parts/friction/friction.svg"
};